(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    const initializeMobileDrawerLinks = (root = document) => {
    root.querySelectorAll('.lumbv-mobile-drawer a[href]').forEach((link) => {
      if (link.dataset.drawerCloseInitialized === 'true') return;
      link.dataset.drawerCloseInitialized = 'true';
      link.addEventListener('click', (event) => {
        const drawer = link.closest('header-drawer');
        const summary = drawer?.querySelector(':scope > details > summary');
        if (drawer?.closeMenuDrawer && summary) drawer.closeMenuDrawer(event, summary);
      });
    });
  };

  const setMobileDrawerMetrics = () => {
    const viewportHeight = window.visualViewport?.height || window.innerHeight || document.documentElement.clientHeight;
    const sectionHeader = document.querySelector('.section-header');
    const headerRect = sectionHeader?.getBoundingClientRect();
    const drawerTop = Math.max(0, Math.round(headerRect?.height || 0));
    const drawerHeight = Math.max(0, Math.round(viewportHeight - (headerRect?.bottom || drawerTop)));

    document.documentElement.style.setProperty('--lumbv-viewport-height', `${Math.round(viewportHeight)}px`);
    document.documentElement.style.setProperty('--lumbv-drawer-top', `${drawerTop}px`);
    document.documentElement.style.setProperty('--lumbv-drawer-height', `${drawerHeight}px`);
  };

  const syncMobileDrawerState = (root = document) => {
    root.querySelectorAll('header-drawer > details').forEach((details) => {
      if (details.dataset.drawerStateInitialized === 'true') return;
      details.dataset.drawerStateInitialized = 'true';

      const updateState = () => {
        const isOpen = details.hasAttribute('open');
        if (isOpen) setMobileDrawerMetrics();
        document.documentElement.classList.toggle('lumbv-drawer-open', isOpen);
        document.body.classList.toggle('lumbv-drawer-open', isOpen);
      };

      updateState();
      details.addEventListener('toggle', updateState);
      new MutationObserver(updateState).observe(details, { attributes: true, attributeFilter: ['open', 'class'] });
    });
  };

  setMobileDrawerMetrics();
  window.addEventListener('resize', setMobileDrawerMetrics, { passive: true });
  window.visualViewport?.addEventListener('resize', setMobileDrawerMetrics, { passive: true });
  window.visualViewport?.addEventListener('scroll', setMobileDrawerMetrics, { passive: true });

  initializeMobileDrawerLinks();
  syncMobileDrawerState();
  document.addEventListener('shopify:section:load', (event) => {
    initializeMobileDrawerLinks(event.target);
    syncMobileDrawerState(event.target);
    setMobileDrawerMetrics();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    const initializeLumbvHeaderMenus = (root = document) => {
    root.querySelectorAll('[data-lumbv-desktop-nav]').forEach((navigation) => {
      if (navigation.dataset.clickMenuInitialized === 'true') return;
      navigation.dataset.clickMenuInitialized = 'true';

      const items = Array.from(navigation.querySelectorAll('[data-lumbv-menu-item]'));
      const updateHeaderBottom = () => {
        const headerSection = navigation.closest('.section-header');
        const bottom = headerSection ? headerSection.getBoundingClientRect().bottom : navigation.getBoundingClientRect().bottom;
        document.documentElement.style.setProperty('--header-bottom-position-desktop', Math.max(0, bottom) + 'px');
      };

      window.addEventListener('resize', updateHeaderBottom);
      window.addEventListener('scroll', updateHeaderBottom, { passive: true });
      updateHeaderBottom();

      const closeItem = (item, returnFocus = false) => {
        const trigger = item.querySelector(':scope > [data-lumbv-menu-trigger]');
        const panel = item.querySelector(':scope > [data-lumbv-menu-panel]');
        const overlay = item.querySelector(':scope > [data-navigation-overlay]');
        if (!trigger || !panel) return;

        item.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        panel.hidden = true;
        if (overlay) overlay.hidden = true;
        if (returnFocus) trigger.focus();
      };

      const closeAll = (exceptItem = null, returnFocus = false) => {
        items.forEach((item) => {
          if (item !== exceptItem && item.classList.contains('is-open')) {
            closeItem(item, returnFocus);
          }
        });
      };

      const openItem = (item) => {
        const trigger = item.querySelector(':scope > [data-lumbv-menu-trigger]');
        const panel = item.querySelector(':scope > [data-lumbv-menu-panel]');
        const overlay = item.querySelector(':scope > [data-navigation-overlay]');
        if (!trigger || !panel) return;

        updateHeaderBottom();
        closeAll(item);
        item.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
        if (overlay) overlay.hidden = false;
      };

      items.forEach((item) => {
        const trigger = item.querySelector(':scope > [data-lumbv-menu-trigger]');
        const overlay = item.querySelector(':scope > [data-navigation-overlay]');
        if (!trigger) return;

        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          if (item.classList.contains('is-open')) {
            closeItem(item);
          } else {
            openItem(item);
          }
        });

        overlay?.addEventListener('click', () => closeItem(item, true));
      });

      document.addEventListener('click', (event) => {
        if (!navigation.contains(event.target)) closeAll();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const openItemElement = items.find((item) => item.classList.contains('is-open'));
        if (!openItemElement) return;
        event.preventDefault();
        closeItem(openItemElement, true);
      });

      document.addEventListener('shopify:block:select', (event) => {
        const selectedItem = items.find(
          (item) => item.dataset.navigationBlockId === event.detail.blockId
        );
        if (selectedItem?.querySelector(':scope > [data-lumbv-menu-trigger]')) openItem(selectedItem);
      });

      document.addEventListener('shopify:block:deselect', (event) => {
        const selectedItem = items.find(
          (item) => item.dataset.navigationBlockId === event.detail.blockId
        );
        if (selectedItem) closeItem(selectedItem);
      });

      navigation.querySelectorAll('[data-product-mega]').forEach((mega) => {
        const tabs = Array.from(mega.querySelectorAll('[data-mega-tab]'));
        const panels = Array.from(mega.querySelectorAll('[data-mega-panel]'));
        const shopAll = mega.querySelector('[data-mega-shop-all]');

        const activateTab = (tab) => {
          const index = tab.dataset.megaTab;
          tabs.forEach((item) => {
            const isActive = item === tab;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', String(isActive));
            item.tabIndex = isActive ? 0 : -1;
          });
          panels.forEach((panel) => {
            const isActive = panel.dataset.megaPanel === index;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          });
          if (shopAll) {
            const title = tab.dataset.megaTitle || '';
            shopAll.textContent = `Shop All ${title}`.trim();
            if (tab.dataset.megaUrl) shopAll.setAttribute('href', tab.dataset.megaUrl);
          }
        };

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => activateTab(tab));
          tab.addEventListener('keydown', (event) => {
            if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
            event.preventDefault();
            const direction = event.key === 'ArrowDown' ? 1 : -1;
            const nextIndex = (tabs.indexOf(tab) + direction + tabs.length) % tabs.length;
            tabs[nextIndex].focus();
            activateTab(tabs[nextIndex]);
          });
        });
      });
    });
  };

  initializeLumbvHeaderMenus();
  document.addEventListener('shopify:section:load', (event) => initializeLumbvHeaderMenus(event.target));
  } catch(e) { console.error(e); }
})();

})();
